/* eslint-disable operator-assignment */
import React from "react";
import dayjs from "dayjs";
import { PAYMENT_STATUS } from "../../data";
import { getPaymentDetailStatus } from "../../getPaymentStatus";

export const statusOptions = [
  {
    id: PAYMENT_STATUS.PENDING,
    value: getPaymentDetailStatus(PAYMENT_STATUS.PENDING),
  },
  {
    id: PAYMENT_STATUS.COMPLETED,
    value: getPaymentDetailStatus(PAYMENT_STATUS.COMPLETED),
  },
];

export const paymentTransactionColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Date & Time
      </div>
    ),
    dataIndex: "submittedAt",
    sorter: (a, b) =>
      a.submittedAt.toString().localeCompare(b.submittedAt.toString()),
    render: (text) => (
      <div>
        <p className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
          {dayjs(text).format("DD-MM-YYYY")}
        </p>
        <p className="text-10 font-normal font-aileron leading-3 text-dark-gray">
          {dayjs(text).format("hh:mm:ss")}
        </p>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Amount
      </div>
    ),
    dataIndex: "totalAmountPaid",
    sorter: (a, b) => a.totalAmountPaid - b.totalAmountPaid,
    render: (text) => (
      <p className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {+text > 0 ? `${+text} KSH` : "--"}
      </p>
    ),
  },
];

export const DRIVER_OPERATION_TYPE = {
  TRIP: 1,
  SESSION: 2,
};

export const exportColumns = [
  { field: "driverId", title: "Driver ID" },
  { field: "driverName", title: "Driver Name" },
  { field: "tripId", title: "Trip ID" },
  { field: "date", title: "Date" },
  { field: "distance", title: "Distance Covered" },
  { field: "total", title: "Total" },
];
